var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.178,
    height: 17.409,
    viewBox: "0 0 13.178 17.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interes",
    transform: "translate(-151.501 -95.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7704",
    "data-name": "Trazado 7704",
    d: "M206.25,160.141a3.155,3.155,0,0,1-3.011-3.274,3.412,3.412,0,0,1,.862-2.3,2.871,2.871,0,0,1,2.15-.98,3.287,3.287,0,0,1,0,6.55Z",
    transform: "translate(-51.738 -56.586)",
    fill: "#f4ce73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7706",
    "data-name": "Trazado 7706",
    d: "M541.654,575.2a3.287,3.287,0,0,1,0-6.55,2.872,2.872,0,0,1,2.149.98,3.412,3.412,0,0,1,.862,2.3A3.155,3.155,0,0,1,541.654,575.2Z",
    transform: "translate(-379.987 -462.791)",
    fill: "#79ccbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7708",
    "data-name": "Trazado 7708",
    d: "M628.8,660.154a1.413,1.413,0,1,1,1.1-1.379A1.266,1.266,0,0,1,628.8,660.154Z",
    transform: "translate(-467.144 -549.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7710",
    "data-name": "Trazado 7710",
    d: "M290.893,243.3a1.413,1.413,0,1,1,1.1-1.379A1.266,1.266,0,0,1,290.893,243.3Z",
    transform: "translate(-136.443 -141.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_225",
    "data-name": "L\\xEDnea 225",
    y1: 14.676,
    x2: 8.497,
    transform: "translate(153.842 97.318)",
    fill: "none",
    stroke: "#f96e43",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.cb8d2f3cbe9d15732c12921de1074d33.svg";
export { ForwardRef as ReactComponent };